import { booleanAttribute } from "#ce/utils/props";

const sizeOptions = ["small", "medium", "large"];

export const props = Object.freeze({
  /**
   * Hero height preset. "small" is 340px (416px on mobile); "medium" is 540px on every breakpoint; "large" is 800px (700px on mobile). Override the matching --sp-comp-hero-size-* token for a custom value.
   *
   * @type {String}
   * @default "medium"
   * @storybook-control select
   */
  size: {
    type: String,
    default: "medium",
    validator: (value) => sizeOptions.includes(value),
  },
  /**
   * Auto-advance through the slides on the configured interval. Pauses automatically when the hero scrolls off-screen via an IntersectionObserver.
   *
   * @type {Boolean|String}
   * @default false
   */
  autoplay: booleanAttribute(),
  /**
   * Time between slide advances in milliseconds. Used by autoplay and to prefetch the next slide's image.
   *
   * @type {Number|String}
   * @default undefined
   * @storybook-control number
   */
  interval: {
    type: [Number, String],
    default: undefined,
  },
  /**
   * Stretch the slide background to the full viewport width (100vw) while keeping the content padding aligned with the page grid.
   *
   * @type {Boolean|String}
   * @default false
   */
  fullbleed: booleanAttribute(),
  /**
   * Round the slide corners using the default border-radius token.
   *
   * @type {Boolean|String}
   * @default false
   */
  rounded: booleanAttribute(),
});
